import { useContext } from 'react';
import { TetrisThemeContext } from './Provider.js';

var useTetrisTheme = function useTetrisTheme() {
  var context = useContext(TetrisThemeContext);
  if (!context) {
    throw new Error('useTetrisTheme was used outside of the TetrisThemeContext');
  }
  return context;
};

export { useTetrisTheme };
